import _Set from "@babel/runtime-corejs3/core-js-stable/set";
var SUPPORTED_HTML_CONTAINER = new _Set(['div', 'form', 'article', 'ul', 'ol', 'li']);
export var isSupportedHTMLContainer = function isSupportedHTMLContainer(component) {
  return SUPPORTED_HTML_CONTAINER.has(component);
};